<label class="st-field-label">{{ label }}</label>
<input [id]="idVal" class="form-control st-input-text-field" [placeholder]="placeHolderVal" type="text"
       [ngStyle]="{
          'width': width
       }"
       [value]="inputVal"
       [disabled]="disabled"
       [required]="requiredVal"
       [maxLength]="this.maxLength"
       (keyup)="filterData(filter.value, $event)"
       #filter (click)="visible = true"
       [(ngModel)]="inputData['complete']"
>
<ul class="list-group" *ngIf="visible" [ngStyle]="{
          'width': width
       }">
  <li class="list-group-item" *ngFor="let item of itemsFilter" (click)="selectItem(item)">
    {{item[this.keyLookup]}}
  </li>
  <li class="list-group-item" (click)="hide()">
    <b>Hide</b>
  </li>
</ul>
